import { useWeb3Modal } from '@web3modal/wagmi/react'
import { useAccount, useDisconnect } from 'wagmi'

export function Navigation() {
  const { open } = useWeb3Modal()
  const { address, isConnected } = useAccount()
  const { disconnect } = useDisconnect()

  return (
    <>
      {/* Wallet button at absolute top left, only on desktop */}
      <div className="absolute top-20 left-4 z-50 hidden md:block">
        {isConnected ? (
          <div className="flex items-center gap-2">
            <span className="text-white/80 text-base bg-black/70 px-3 py-2 rounded">
              {address?.slice(0, 6)}...{address?.slice(-4)}
            </span>
            <button
              onClick={() => disconnect()}
              className="px-6 py-3 text-base font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
            >
              Disconnect
            </button>
          </div>
        ) : (
          <button
            onClick={() => open()}
            className="px-6 py-3 text-base font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
          >
            Connect Wallet
          </button>
        )}
      </div>
      {/* Main nav bar */}
      <nav className="fixed top-0 left-0 right-0 z-40 bg-black/80 backdrop-blur-sm border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0">
              <h1 className="text-white text-xl font-bold">Regret Roulette</h1>
            </div>
            {/* Mobile menu button and wallet button */}
            <div className="md:hidden flex items-center flex-wrap min-w-0">
              {/* Hamburger menu placeholder (could be expanded for more links) */}
              {/* Wallet button for mobile */}
              {isConnected ? (
                <div className="flex items-center gap-1 flex-wrap min-w-0">
                  <span className="text-white/80 text-xs bg-black/70 px-2 py-1 rounded min-w-0 overflow-hidden text-ellipsis max-w-[90px]">
                    {address?.slice(0, 6)}...{address?.slice(-4)}
                  </span>
                  <button
                    onClick={() => disconnect()}
                    className="px-2 py-1 text-xs font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors whitespace-nowrap"
                    style={{ maxWidth: "80px" }}
                  >
                    Disconnect
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => open()}
                  className="px-2 py-1 text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
                >
                  Connect Wallet
                </button>
              )}
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}
